import {
  CLEAN,
  FETCH,
  INITIALIZE,
  REFRESH,
  received,
  error,
  fetch,
  refresh,
} from '../store/modules/headlines'
import { combineEpics, ofType } from 'redux-observable'
import { filter, interval, map, mergeMap, switchMap, takeUntil, withLatestFrom } from 'rxjs'
import { defaultTo, map as fmap, pipe } from 'ramda'
import { logObservableError, logObservableErrorAndTriggerAction } from '../utilities/logs'
import { formatArticle } from '../utilities/miscellaneous'
import { ARTICLE_TYPE } from '../utilities/constants'

// initializeEpic :: Epic -> Observable Action.FETCH
export const initializeEpic = (action$, state$, { logger }) =>
  action$.pipe(
    ofType(INITIALIZE),
    map(({ categoryId }) => fetch(categoryId)),
    logObservableError('headlines :: initializeEpic', logger),
  )

// initializeAutoRefreshEpic :: Epic -> Observable Action.FETCH
export const initializeAutoRefreshEpic = (action$, state$, { logger }) =>
  action$.pipe(
    ofType(INITIALIZE),
    filter(({ autoRefresh }) => autoRefresh),
    switchMap(({ categoryId }) => interval(2 * 60 * 1000).pipe(
      takeUntil(action$.pipe(ofType(CLEAN))),
      map(() => refresh(categoryId)),
    )),
    logObservableError('headlines :: initializeAutoRefreshEpic', logger),
  )

// fetchEpic :: Epic -> Observable Action.RECEIVED
export const fetchEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(FETCH, REFRESH),
    withLatestFrom(state$),
    mergeMap(([ { categoryId }, state ]) => Promise.all([
      fetchApi(
        categoryId
          ? `/v2/${state.router.locale}/categories/${categoryId}/headlines`
          : `/v2/${state.router.locale}/homepage/headlines`,
      ),
      state.router.locale,
    ])),
    map(([ response, locale ]) => received(
      (response.body || []).map(headline => headline.type === ARTICLE_TYPE
        ? { ...headline, item: formatArticle(locale, headline.item) }
        : headline,
      ),
    )),
    logObservableErrorAndTriggerAction('headlines :: fetchEpic', error, logger),
  )

export default combineEpics(
  initializeEpic,
  initializeAutoRefreshEpic,
  fetchEpic,
)
